import { defineMessages } from 'react-intl';

export const errors = defineMessages({
  networkError: {
    id: 'state.networkError',
    defaultMessage:
      'Connection failure. Please ensure you are connected to the Internet.'
  }
});

export function createErrorModel(originalError) {
  let publicMessage = null;

  // Handle network errors
  if (
    (originalError.request && !originalError.response) ||
    originalError.message === 'Network Error'
  ) {
    publicMessage = errors.networkError;
  }

  return {
    httpStatusCode:
      originalError.response && originalError.response.status >= 400
        ? originalError.response.status
        : null,
    publicMessage
  };
}



// WEBPACK FOOTER //
// ./src/util/error.js